import Units from "../../../utils/Units";
import Time from "../axes/Time";
import Dbm from "../axes/Dbm";

let ConnectionSignalStrength = {
    type: "line",
    label: "Connection Signal Strength",
    fill: false,
    lineTension: 0,
    colorPalette: 9,
    borderWidth:2,

    pointStyle: "circle",
    pointRadius:0,
    pointHoverRadius: 2,
    pointBorderWidth:.5,
    z:50,

    tooltipLabelValueCallback: (value) => {
        return Units.rounded(value,2);
    },

    yAxis:Dbm,
    xAxis:Time
};

export default ConnectionSignalStrength;



// WEBPACK FOOTER //
// ./src/components/chart/channels/ConnectionSignalStrength.js